const menuConfig = [
  {
    title: 'Home',
    path: '/'
  },
  {
    title: 'About us',
    path: '/about-us'
  },
  {
    title: 'Services',
    path: '/services'
  },
  {
    title: 'News & Events',
    path: '/news-events'
  },
  {
    title: 'Contact Us',
    path: '/contact-us'
  }
];

export default menuConfig;
